<script module>
  import FilenameColumn from "./columns/FilenameColumn.svelte";
  import SizeColumn from "./columns/SizeColumn.svelte";
  import TypeColumn from "./columns/TypeColumn.svelte";
  import UploadDateColumn from "./columns/UploadDateColumn.svelte";

  export let snippets = { filename, type, size, uploaded };
</script>

{#snippet filename(value, row)}
  <FilenameColumn {value} skeleton={!row} />
{/snippet}

{#snippet type(value, row)}
  <TypeColumn {value} skeleton={!row} />
{/snippet}

{#snippet size(value, row)}
  <SizeColumn {value} skeleton={!row} />
{/snippet}

{#snippet uploaded(value, row)}
  <UploadDateColumn {value} skeleton={!row} />
{/snippet}
